import PropTypes from 'prop-types'

const Arrows = ({ color, width, height, flip }) => {
  const amtToRotate = flip ? -90 : 90
  const amtToTranslate1 = flip ? '3148 1311' : '3159 1292'
  const amtToTranslate2 = flip ? '3154 1311' : '3165 1292'
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      //width="16.235"
      //height="19.479"
      width={width}
      height={height}
      viewBox="0 0 16 19"
    >
      <g id="Group_74" transform="translate(-3149 -1292)" fill={color}>
        <path
          id="Subtraction_1"
          d="M3.542 9.741H0L9.74 0l9.739 9.739h-3.54l-6.2-6.2-6.2 6.2z"
          transform={`translate(${amtToTranslate1}) rotate(${amtToRotate})`}
        />
        <path
          id="Subtraction_2"
          d="M3.542 9.741H0L9.74 0l9.739 9.739h-3.54l-6.2-6.2-6.2 6.2z"
          transform={`translate(${amtToTranslate2}) rotate(${amtToRotate})`}
        />
      </g>
    </svg>
  )
}
export default Arrows
//3165.734 1292.501

Arrows.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  flip: PropTypes.bool
}
